import { type DirectusLocation } from "@/custom-types/Directus";

export const getTargetedData = <T extends DirectusLocation>(
  data: T[],
  userState: string,
) => {
  let items = data.filter((item) =>
    item.targeting?.states_or_provinces?.find(
      (state: string) => state.trim() === userState,
    ),
  );

  if (!items.length) {
    items = data?.filter((item) => {
      const states = item.targeting?.states_or_provinces?.filter(Boolean);
      return !states?.length;
    });
  }

  return items;
};
